import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const HttpRequestBtnWidget: WidgetRegistryEntry = {
  name: "HttpRequestButton",
  component: () => import("./http-request-btn-widget.component").then((m) => m.HttpRequestBtnWidgetComponent),
  configuration: () => import("./configuration").then((m) => m.HttpRequestBtnWidgetConfiguration)
};
